module.exports = __webpack_public_path__ + "static/media/report_rephrase_white.61980dc1.svg";